<section class="account-verification">
    <div class="pn-container">
        <div class="verify-container">
            <svg-icon class="verify-icon" [src]="verifyIcon" />
            <div class="verify-content">
                @switch (verificationStep) {
                    @case (verificationStepEnum.Success) {
                        <ng-container *ngTemplateOutlet="verifySuccess"></ng-container>
                    }
                    @case (verificationStepEnum.Failure) {
                        <ng-container *ngTemplateOutlet="verifyFailure"></ng-container>
                    }
                    @case (verificationStepEnum.ResendSuccess) {
                        <ng-container *ngTemplateOutlet="reSendEmailSuccess"></ng-container>
                    }
                    @case (verificationStepEnum.ResendFailure) {
                        <ng-container *ngTemplateOutlet="reSendEmailFailure"></ng-container>
                    }
                }
            </div>
        </div>
    </div>
</section>

<ng-template #verifySuccess>
    <svg-icon
        #verifyContentIcon
        class="verify-content__check-in-icon"
        [ngClass]="{ 'verify-content__icon': !loading() }"
        src="/assets/icons/verify-check-in.svg"
        svgClass="size-[80px] mb:size-[78px]"
    />
    <h2 class="verify-content__title" i18n="@@account-verification.success.title">
        Xác thực thành công
    </h2>
    <p class="verify-content__description" i18n="@@account-verification.success.description">
        Tài khoản của bạn đã được xác thực thành công. Vui lòng nhấp vào nút bên dưới để đăng nhập
        và tiếp tục đặt vé
    </p>
    <button
        pnButton
        class="px-4 font-lato-bold text-base font-bold"
        (click)="handleSignIn($event)"
        type="button"
        i18n="@@account-verification.success.sign-in-btn"
    >
        Đăng nhập ngay
    </button>
</ng-template>

<ng-template #verifyFailure>
    <svg-icon
        #verifyContentIcon
        [ngClass]="{ 'verify-content__icon': !loading() }"
        src="/assets/icons/fi-rr-cross-circle.svg"
        class="verify-content__check-in-icon"
        svgClass="size-[80px] mb:size-[78px]"
    />
    <h2 class="verify-content__title" i18n="@@account-verification.failure.title">
        Xác thực không thành công
    </h2>
    <p class="verify-content__description" i18n="@@account-verification.failure.description">
        Mã kích hoạt tài khoản của bạn đã hết hạn do quá thời gian quy định. Để hoàn tất việc đăng
        ký, vui lòng yêu cầu mã kích hoạt mới.
    </p>
    <button
        pnButton
        class="flex gap-2 px-4 flex-row-center mb:mt-3"
        type="button"
        (click)="reSendVerifyEmail()"
    >
        <svg-icon
            src="assets/icons/loading.svg"
            *ngIf="loading()"
            svgClass="size-4 animate-spin"
            class="icon:fill-neutral-01"
        />
        <span
            class="font-lato-bold text-base font-bold"
            i18n="@@account-verification.failure.re-send-btn"
        >
            Gửi lại email kích hoạt
        </span>
    </button>
</ng-template>

<ng-template #reSendEmailSuccess>
    <svg-icon
        src="/assets/icons/verify-check-in.svg"
        svgClass="size-[80px] mb:size-[78px]"
        [ngClass]="{ 'verify-content__icon': !loading() }"
    />
    <h2 class="verify-content__title" i18n="@@account-verification.re-send-email-success.title">
        Gửi email xác thực thành công
    </h2>
    <p
        class="verify-content__description"
        i18n="@@account-verification.re-send-email-success.description"
    >
        Một email kích hoạt đã được gửi đến địa chỉ email của bạn. Vui lòng kiểm tra email để kích
        hoạt tài khoản
    </p>
</ng-template>

<ng-template #reSendEmailFailure>
    <svg-icon
        src="/assets/icons/fi-rr-cross-circle.svg"
        [ngClass]="{ 'verify-content__icon': !loading() }"
        svgClass="size-[80px] mb:size-[78px]"
    />
    <h2 class="verify-content__title" i18n="@@account-verification.re-send-email-failure.title">
        Gửi email xác thực không thành công
    </h2>
    <p
        class="verify-content__description"
        i18n="@@account-verification.re-send-email-failure.description"
    >
        Gửi email kích hoạt không thành công. Vui lòng liên hệ với chúng tôi để được hỗ trợ thêm.
    </p>
</ng-template>
